import React from 'react';

// ServiceCard component to display each service item
const ServiceCard = ({ image, title, link }) => {
  return (
    <div className="col-md-4 col-sm-4 col-xs-12 marbtm50 service-list-column">
      <a href={link}>
        <span className="image_hover">
          <img src={image} className="img-responsive zoom_img_effect" alt={`${title}-image`} />
        </span>
        <div className="service-heading">
          <h5>{title}</h5>
          {/* <span className="read-more-link">Read More</span> */}
        </div>
      </a>
    </div>
  );
};

// Main Services component
const Services = () => {
  const services = [
    {
      title: "Aluminium Glass Office Partition",
      image: "images/home2-images/home2-manufacturing-img.jpg",
      link: "aluminium-glass-partition.html",
    },
    {
      title: "Toughened Glass Work & Door Partition",
      image: "images/home2-images/home2-cncindustry-img.jpg",
      link: "toughened-glass.html",
    },
    {
      title: "ACP Cladding Panel Installation",
      image: "images/home2-images/home2-chemicalindustry-img.jpg",
      link: "acp-cladding.html",
    },
    {
      title: "Soundproof & Aluminium Glass Windows",
      image: "images/home2-images/home2-energyengineering-img.jpg",
      link: "soundproof-windows.html",
    },
    {
      title: "Bird Net & Invisible Grill Installation",
      image: "images/home2-images/home2-oilindustry-img.jpg",
      link: "bird-net.html",
    },
    {
      title: "MS Fabrication for Doors, Shades & Grills",
      image: "images/home2-images/home2-materialengineering-img.jpg",
      link: "ms-fabrication.html",
    },
  ];

  return (
    <div>
      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1>Our Services</h1>
        </div>
      </div>

      {/* Services Section */}
      <section className="pad100-50-top-bottom">
        <div className="container">
          <div className="row">
            <div className="head-section service-head other-heading">
              <div className="col-lg-3 col-md-4 col-sm-5 col-xs-12">
                <h3>Our Services</h3>
              </div>
              <div className="col-lg-9 col-md-8 col-sm-7 col-xs-12">
                <p className="fnt-18">
                  At Anjali Enterprises, we provide top-notch services tailored for industrial and residential needs, 
                  ensuring quality craftsmanship and unmatched customer satisfaction. From aluminium glass solutions 
                  to complete renovation work, we have you covered.
                </p>
              </div>
            </div>

            {/* Map through services and display ServiceCard for each */}
            {services.map((service, index) => (
              <ServiceCard 
                key={index} 
                title={service.title} 
                image={service.image} 
                // link={service.link} 
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;







// import React from 'react';

// // ServiceCard component to display each service item
// const ServiceCard = ({ image, title, link }) => {
//   return (
//     <div className="col-md-4 col-sm-4 col-xs-12 marbtm50 service-list-column">
//       <a href={link}>
//         <span className="image_hover">
//           <img src={image} className="img-responsive zoom_img_effect" alt={`${title}-image`} />
//         </span>
//         <div className="service-heading">
//           <h5>{title}</h5>
//           <span className="read-more-link">Read More</span>
//         </div>
//       </a>
//     </div>
//   );
// };

// // Main Services component
// const Services = () => {
//   const services = [
//     {
//       title: "MANUFACTURING",
//       image: "images/home2-images/home2-manufacturing-img.jpg",
//       link: "manufacturing.html",
//     },
//     {
//       title: "CNC INDUSTRY",
//       image: "images/home2-images/home2-cncindustry-img.jpg",
//       link: "cnc-industry.html",
//     },
//     {
//       title: "CHEMICAL INDUSTRY",
//       image: "images/home2-images/home2-chemicalindustry-img.jpg",
//       link: "chemical-industry.html",
//     },
//     {
//       title: "ENERGY ENGINEERING",
//       image: "images/home2-images/home2-energyengineering-img.jpg",
//       link: "energy-engineering.html",
//     },
//     {
//       title: "OIL INDUSTRY",
//       image: "images/home2-images/home2-oilindustry-img.jpg",
//       link: "oil-industry.html",
//     },
//     {
//       title: "MATERIAL ENGINEERING",
//       image: "images/home2-images/home2-materialengineering-img.jpg",
//       link: "material-engineering.html",
//     }
//   ];

//   return (
//     <div>
//       {/* Banner */}
//       <div className="inner-pages-bnr">
//         <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
//         <div className="banner-caption">
//           <h1>Services</h1>
          
//         </div>
//       </div>

//       {/* Services Section */}
//       <section className="pad100-50-top-bottom">
//         <div className="container">
//           <div className="row">
//             <div className="head-section service-head other-heading">
//               <div className="col-lg-3 col-md-4 col-sm-5 col-xs-12">
//                 <h3>OUR services</h3>
//               </div>
//               <div className="col-lg-9 col-md-8 col-sm-7 col-xs-12">
//                 <p className="fnt-18">
//                   Etiam porta sem malesuada magna mollis euismod. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Maecenas faucibus mollis interdum. Donec id elit non mi porta gravida at eget metus. Aenean lacinia. Donec ullamcorper nulla non metus auctor fringilla.
//                 </p>
//               </div>
//             </div>

//             {/* Map through services and display ServiceCard for each */}
//             {services.map((service, index) => (
//               <ServiceCard 
//                 key={index} 
//                 title={service.title} 
//                 image={service.image} 
//                 link={service.link} 
//               />
//             ))}
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Services;
